export const logindata = {
    GET_LOGINDATA: "GET_LOGINDATA",

}
